import { axios } from '@/utils/request'

/**
 * api接口列表
 */
const apiPath = {
  login: '/api/v1/login',
  register: '/api/v1/register',
  resetPwd: '/api/v1/resetPwd',
  logout: '/api/v1/web/user/logout',
  info: '/api/v1/pms/web/user/userInfo',
  modifyPwd: '/api/v1/pms/web/user/modifyPwd',
  modifyName: '/api/v1/pms/web/user/modifyName',
  modifyPhone: '/api/v1/pms/web/user/modifyPhone',
  getCode: '/api/v1/verifyCode',
  modifyAvatar: '/api/v1/pms/web/user/modifyIcon'
}
/**
 * 用户登录
 * @param {*} data
 */
 export function login (data) {
  return axios({
    url: apiPath.login,
    method: 'post',
    data
  })
}

/**
 * 用户登录
 * @param {*} data
 */
 export function register (data) {
  return axios({
    url: apiPath.register,
    method: 'post',
    data
  })
}
/**
 * 重置密码
 * @param {*} data
 */
 export function resetPwd (data) {
  return axios({
    url: apiPath.resetPwd,
    method: 'post',
    data
  })
}
export function logout () {
  return axios({
    url: apiPath.logout,
    method: 'get'
  })
}

/**
 * 获取当前登录的用户信息
 */
export function getInfo () {
  return axios({
    url: apiPath.info,
    method: 'get'
  })
}

/**
 * 修改密码
 * @param {*} data
 */
 export function modifyPwd (data) {
  return axios({
    url: apiPath.modifyPwd,
    method: 'post',
    data
  })
}

/**
 * 修改姓名
 * @param {*} data
 */
 export function modifyName (name) {
  return axios({
    url: apiPath.modifyName,
    method: 'get',
    params: { name }
  })
}


/**
 * 修改手机号
 * @param {*} data
 */
 export function modifyPhone (data) {
  return axios({
    url: apiPath.modifyPhone,
    method: 'post',
    data
  })
}

/**
 * 添加部门
 * @param {*} data
 */
 export function getCode (data) {
  return axios({
    url: apiPath.getCode,
    method: 'get',
    params: { phone:data.phone,key:data.key}
  })
}


/**
 * 添加部门
 * @param {*} data
 */
 export function modifyAvatar (icon) {
  return axios({
    url: apiPath.modifyAvatar,
    method: 'get',
    params: { icon }
  })
}

